// Surface tokens. Historically glassmorphism (translucent white +
// backdrop-blur) designed to read over a page background bloom; since
// the bloom was removed these are SOLID layered surfaces instead:
// white chrome/cards on a gray content canvas (light), and a
// canvas→surface→raised tone stack (dark). Names retain the "glass"
// prefix to avoid touching ~27 call sites — rename in a later pass.

// Cards/panels — solid white on the gray canvas, solid bg-surface on dark.
export const glassCard =
  'border border-black/[0.06] bg-surface-white shadow-soft ' +
  'dark:border-bg-line dark:bg-bg-surface dark:shadow-v2-card-dark'

// Inset chips/controls — recessed gray inside a white card, raised on dark.
export const glassChip =
  'border border-black/[0.06] bg-surface-light ' +
  'dark:border-bg-line dark:bg-bg-raised'

// Colour only. The Lora-serif heading treatment is applied to the
// heading *elements* (h1/h2/h3) in index.css, not coupled to this
// colour token — this token is also used on some non-heading text.
export const textHeading = 'text-v2-ink dark:text-v2-ink-inv'
export const textBody = 'text-v2-ink-dim dark:text-v2-ink-inv-dim'
export const textMuted = 'text-v2-ink-muted dark:text-v2-ink-inv-muted'

export const brandGradient = 'bg-v2-brand dark:bg-v2-brand-dark'
export const brandText =
  'bg-v2-brand dark:bg-v2-brand-dark bg-clip-text text-transparent'

export const brandButton =
  `${brandGradient} text-white font-semibold rounded-full shadow-v2-btn dark:shadow-v2-btn-dark ` +
  'transition-transform hover:scale-[1.02] active:scale-[0.98]'

export const ghostButton =
  'border border-black/10 bg-black/[0.04] text-v2-ink-muted rounded-full ' +
  'hover:bg-black/[0.06] dark:border-white/10 dark:bg-white/[0.05] dark:text-v2-ink-inv-muted dark:hover:bg-white/[0.08]'

// Round icon buttons used in the CoursePlayer header (sidebar / refocus
// / export / theme / memory toggles). Shared so every header affordance —
// including ThemeToggle and the MemoryFeed collapse — looks identical.
// Solid surface (bg-raised on dark) with `shadow-md` to lift it off the
// header; the card-grade `shadow-v2-card` would puddle on a small surface.
//
// Sized at 44×44 on mobile to meet the WCAG 2.5.5 / Apple HIG touch-
// target minimum, shrinking back to 36×36 at sm+ where pointer accuracy
// goes up and the header would otherwise look top-heavy.
export const iconButton =
  'flex h-11 w-11 items-center justify-center rounded-full border border-black/[0.06] bg-surface-white text-v2-ink-muted shadow-md transition hover:scale-105 dark:border-bg-line dark:bg-bg-raised dark:text-v2-ink-inv-muted dark:shadow-none sm:h-9 sm:w-9'

// Page background = the content canvas: a subtle gray (#f5f5f8) in light
// so white chrome/cards separate from it; bg-canvas (#0d1117) in dark.
export const pageBackground = 'min-h-screen bg-surface-light dark:bg-bg-canvas'
